import { FC, memo } from 'react';
import filter from 'lodash/filter';
import map from 'lodash/map';

import ColumnsItem from 'components/CustomizeDisplayTable/ColumnsItem';
import { IColumnsProps } from 'components/CustomizeDisplayTable/constants';
import { ICustomizeTableColumn } from 'types/listsTypes';

const Columns: FC<IColumnsProps> = ({ columns, setColumns }) =>
  <div>
    {map(filter(columns, 'title'), ({ dataIndex, title, isChecked, isFixed }: ICustomizeTableColumn, index: number) =>
      <ColumnsItem
        key={dataIndex}
        index={index}
        id={dataIndex}
        title={title}
        isFixed={isFixed}
        isChecked={isChecked}
        onColumn={setColumns}
      />)}
  </div>;

export default memo(Columns);
